module.exports = __webpack_public_path__ + "static/media/logo.34e64b8f.png";